/* wbn-body.js: former inline <script> blocks from the body-tail snippets, one IIFE each,
   original document order. Loaded with defer from layout/theme.liquid. */

/* ---- snippets/header-wishlist-icon.liquid ---- */
  (function () {
    function hasWishlist() {
      try {
        const v = localStorage.getItem('wb_user_wishlist_v1');
        if (!v) return false;
        // consider empty arrays/objects as no wishlist
        if (v === 'null' || v === 'undefined') return false;
        try {
          const parsed = JSON.parse(v);
          if (Array.isArray(parsed) && parsed.length === 0) return false;
          if (typeof parsed === 'object' && Object.keys(parsed).length === 0) return false;
        } catch (_) {
          // not JSON — treat non-empty string as truthy
        }
        return true;
      } catch (_) { return false; }
    }

    function updateIcon() {
      try {
        const root = document.querySelector('.header-wishlist-icon');
        if (!root) return;
        const filled = root.querySelector('.wishlist-icon-filled');
        const empty = root.querySelector('.wishlist-icon-empty');
        if (hasWishlist()) {
          if (filled) filled.style.display = '';
          if (empty) empty.style.display = 'none';
        } else {
          if (filled) filled.style.display = 'none';
          if (empty) empty.style.display = '';
        }
      } catch (_) {}
    }

    // Initial state
    document.addEventListener('DOMContentLoaded', updateIcon);

    // Listen for cross-tab changes
    window.addEventListener('storage', function (e) {
      if (e.key === 'wb_user_wishlist_v1') updateIcon();
    });

    // Listen for custom in-page wishlist updates dispatched by wishlist.js
    window.addEventListener('wb:wishlist:updated', function (e) {
      try {
        // If event provides items, we can shortcut
        if (e && e.detail && e.detail.items) {
          updateIcon();
          return;
        }
      } catch (_) {}
      updateIcon();
    });

    // Intercept localStorage.setItem to catch same-tab updates (only once)
    try {
      if (!localStorage.__wb_setitem_wrapped) {
        localStorage.__wb_setitem_wrapped = true;
        const prev = localStorage.setItem.bind(localStorage);
        localStorage.setItem = function (key, value) {
          const res = prev.apply(this, arguments);
          try { if (key === 'wb_user_wishlist_v1') updateIcon(); } catch (_) {}
          return res;
        };
      }
    } catch (_) {}
    // Intercept removeItem so same-tab deletions update the icon
    try {
      if (!localStorage.__wb_removeitem_wrapped) {
        localStorage.__wb_removeitem_wrapped = true;
        const prevRemove = localStorage.removeItem.bind(localStorage);
        localStorage.removeItem = function (key) {
          const res = prevRemove.apply(this, arguments);
          try { if (key === 'wb_user_wishlist_v1' || key === 'kp_customer_id') updateIcon(); } catch (_) {}
          return res;
        };
      }
    } catch (_) {}

    // Intercept clear to update icon when all keys cleared
    try {
      if (!localStorage.__wb_clear_wrapped) {
        localStorage.__wb_clear_wrapped = true;
        const prevClear = localStorage.clear.bind(localStorage);
        localStorage.clear = function () {
          const res = prevClear.apply(this, arguments);
          try { updateIcon(); } catch (_) {}
          return res;
        };
      }
    } catch (_) {}

    // Polling fallback: some code may mutate localStorage via assignment/delete
    try {
      var __wb_last_wishlist = null;
      var __wb_last_kp = null;
      try { __wb_last_wishlist = localStorage.getItem('wb_user_wishlist_v1'); } catch (_) {}
      try { __wb_last_kp = localStorage.getItem('kp_customer_id'); } catch (_) {}

      setInterval(function () {
        try {
          var cur = null;
          try { cur = localStorage.getItem('wb_user_wishlist_v1'); } catch (_) { cur = null; }
          if (cur !== __wb_last_wishlist) {
            __wb_last_wishlist = cur;
            updateIcon();
          }
        } catch (_) {}
        try {
          var curkp = null;
          try { curkp = localStorage.getItem('kp_customer_id'); } catch (_) { curkp = null; }
          if (curkp !== __wb_last_kp) {
            __wb_last_kp = curkp;
            updateIcon();
          }
        } catch (_) {}
      }, 1000);
    } catch (_) {}
  })();

/* ---- snippets/sticky-barnav.liquid ---- */
            (function () {
              var STYLE_ID = 'wbn-bik-hide-bubble';
              var CSS =
                '#bikCTAWrapper > div:nth-child(2) { display: none !important; }' +
                '.bikCtaContainer, .bikCtaContainer.ripple_animation { box-shadow: none !important; animation: none !important; --before-ripple-color: transparent !important; flex-direction: column !important;}' +
                '.bikCtaContainer.ripple_animation::before, .bikCtaContainer.ripple_animation::after { display: none !important; box-shadow: none !important; animation: none !important; }' +
                '.wbn-ask-ai { font-family: "Open Sans", sans-serif; font-size: 13px !important; line-height: 15px !important; font-weight: 500; color: #400057; margin-left: 6px; white-space: nowrap; }' +
                '.bikCtaButton { height: 26px; width: 26px; }';
              var mq = window.matchMedia('(max-width: 767px)');
              var observers = new WeakMap();

              function ensureStyle(doc) {
                if (!doc.head || doc.getElementById(STYLE_ID)) return;
                var s = doc.createElement('style');
                s.id = STYLE_ID;
                s.textContent = CSS;
                doc.head.appendChild(s);
              }

              function hideBubble(doc) {
                var w = doc.getElementById('bikCTAWrapper');
                if (!w) return;
                var second = w.querySelector(':scope > div:nth-child(2)');
                if (second && second.style.getPropertyValue('display') !== 'none') {
                  second.style.setProperty('display', 'none', 'important');
                }
              }

              function syncOpenState(iframe, doc) {
                var isOpen = false;
                try {
                  var wrapper = doc && doc.querySelector('.chatbot-wrapper');
                  if (wrapper && doc.defaultView.getComputedStyle(wrapper).display !== 'none') {
                    isOpen = true;
                  }
                } catch (e) {}
                // Fallback: when the chat opens BIK grows the iframe height (~90% of the
                // viewport). The collapsed CTA is short, so a tall iframe means it's open —
                // this keeps the width in sync even if the wrapper check misses.
                if (!isOpen && iframe.getBoundingClientRect().height > window.innerHeight * 0.35) {
                  isOpen = true;
                }
                iframe.classList.toggle('wbn-chat-open', isOpen);
              }

              function bindOpenTrigger(iframe, doc) {
                if (iframe._wbnOpenBound || !doc) return;
                iframe._wbnOpenBound = true;
                // Open the chat optimistically on the same tap, so the width snaps to
                // 100% in the same frame BIK grows the height — no white flash. Then
                // reconcile against the real state shortly after.
                doc.addEventListener('click', function () {
                  if (!mq.matches) return;
                  iframe.classList.add('wbn-chat-open');
                  setTimeout(function () { syncOpenState(iframe, doc); }, 450);
                }, true);
              }

              function ensureAskAILabel(doc) {
                var btn = doc.querySelector('.bikCtaButton');
                if (!btn || !btn.parentNode) return;
                var next = btn.nextElementSibling;
                if (next && next.classList && next.classList.contains('wbn-ask-ai')) return;
                var span = doc.createElement('span');
                span.className = 'wbn-ask-ai';
                span.textContent = 'Ask AI';
                btn.parentNode.insertBefore(span, btn.nextSibling);
              }

              function updateLoader(doc) {
                var loader = document.getElementById('wbn-ai-loader');
                if (!loader) return;
                var ready = false;
                if (mq.matches && doc) {
                  var label = doc.querySelector('.wbn-ask-ai');
                  var btn = doc.querySelector('.bikCtaButton');
                  ready = !!(label && btn && doc.defaultView.getComputedStyle(btn).display !== 'none');
                }
                loader.classList.toggle('is-ready', ready);
              }

              function apply(iframe) {
                if (!mq.matches) return;
                try {
                  var doc = iframe.contentDocument;
                  if (!doc || !doc.documentElement) return;
                  ensureStyle(doc);
                  hideBubble(doc);
                  ensureAskAILabel(doc);
                  bindOpenTrigger(iframe, doc);
                  syncOpenState(iframe, doc);
                  updateLoader(doc);
                  if (observers.has(iframe)) return;
                  var obs = new MutationObserver(function () {
                    ensureStyle(doc);
                    hideBubble(doc);
                    ensureAskAILabel(doc);
                    bindOpenTrigger(iframe, doc);
                    syncOpenState(iframe, doc);
                    updateLoader(doc);
                  });
                  obs.observe(doc.documentElement, { childList: true, subtree: true });
                  observers.set(iframe, obs);
                } catch (e) {}
              }

              function scan() {
                document.querySelectorAll('#bik-chat-iframe').forEach(function (f) {
                  if (!f._wbnBikSwap) {
                    f._wbnBikSwap = true;
                    f.addEventListener('load', function () {
                      var prev = observers.get(f);
                      if (prev) { prev.disconnect(); observers.delete(f); }
                      apply(f);
                    });
                    // BIK resizes the iframe's height when the chat opens/closes; track
                    // that from the parent so the width follows and we never get a tall,
                    // 85px-wide white strip.
                    if (window.ResizeObserver) {
                      var ro = new ResizeObserver(function () {
                        if (!mq.matches) return;
                        var d = null;
                        try { d = f.contentDocument; } catch (e) {}
                        syncOpenState(f, d);
                      });
                      ro.observe(f);
                    }
                  }
                  if (f.contentDocument && f.contentDocument.readyState === 'complete') {
                    apply(f);
                  }
                });
              }

              // Was an observer on documentElement from mid-parse; now starts at
              // DOMContentLoaded (parse done, so no per-node records) and only on
              // templates that render the Ask-AI slot (#wbn-ai-loader).
              function start() {
                if (!document.getElementById('wbn-ai-loader')) return;
                new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
                scan();
                mq.addEventListener('change', scan);
              }
              if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
              else start();
            })();

/* ---- snippets/add-to-cart-ribbon.liquid ---- */
  (function () {
    'use strict';

    var TOAST_ID = 'notifyATC';
    var VISIBLE_MS = 2000;
    var DEBOUNCE_MS = 400;
    var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
    var timer = null;
    var lastShownAt = 0;

    function isAddUrl(url) {
      return typeof url === 'string' && ADD_RE.test(url);
    }

    // A WBN2.0 direct checkout clears and re-adds the cart behind a full-screen
    // loader on its way to GoKwik checkout. That is not an "added to cart"
    // moment — the shopper is being taken to checkout — so stay silent while
    // that loader is up, or the toast would flash behind the checkout modal.
    function directCheckoutInFlight() {
      return !!document.getElementById('wbn2-direct-checkout-loader');
    }

    // The Circuit Breaker's Buy Now handler quietly adds the item while blocking
    // checkout, then answers the shopper with its own "checkout paused" pop-up.
    // That is not an "added to cart" moment either — same reasoning as
    // directCheckoutInFlight above — so stay silent for it. A genuine add-to-cart
    // is unaffected and still toasts normally.
    // Window, not a flag: assets/wbn-circuit-breaker.js stamps the time it starts
    // the add, and this runs on the /cart/add response a moment later.
    var CB_QUIET_ADD_MS = 2500;
    function circuitBreakerQuietAdd() {
      var at = window.WBN_CB_QUIET_ADD_AT;
      return typeof at === 'number' && (Date.now() - at) < CB_QUIET_ADD_MS;
    }

    function showToast() {
      if (directCheckoutInFlight()) return;
      if (circuitBreakerQuietAdd()) return;
      var el = document.getElementById(TOAST_ID);
      if (!el) return;
      var now = Date.now();
      // One logical add can fire several /cart/add calls (and a handler may have
      // shown the toast already) — collapse those into a single appearance.
      if (now - lastShownAt < DEBOUNCE_MS) return;
      lastShownAt = now;
      el.classList.add('show');
      clearTimeout(timer);
      timer = setTimeout(function () { el.classList.remove('show'); }, VISIBLE_MS);
    }

    // fetch — observe the returned promise without consuming the body.
    try {
      var nativeFetch = window.fetch;
      if (typeof nativeFetch === 'function' && !nativeFetch.__wbnAtcToast) {
        var wrapped = function (input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var method = (init && init.method) || (input && input.method) || 'GET';
          var p = nativeFetch.apply(this, arguments);
          try {
            if (isAddUrl(url) && /post/i.test(method)) {
              p.then(function (res) { if (res && res.ok) showToast(); }, function () {});
            }
          } catch (e) {}
          return p; // caller gets the original, untouched promise
        };
        wrapped.__wbnAtcToast = true;
        window.fetch = wrapped;
      }
    } catch (e) {}

    // XMLHttpRequest — covers jQuery.ajax (the grid / il-custom-scripts adds).
    try {
      var XHR = window.XMLHttpRequest;
      if (XHR && XHR.prototype && !XHR.prototype.__wbnAtcToast) {
        var origOpen = XHR.prototype.open;
        var origSend = XHR.prototype.send;
        XHR.prototype.open = function (method, url) {
          this.__wbnAtcToastAdd = isAddUrl(url) && /post/i.test(method || '');
          return origOpen.apply(this, arguments);
        };
        XHR.prototype.send = function () {
          if (this.__wbnAtcToastAdd) {
            this.addEventListener('load', function () {
              if (this.status >= 200 && this.status < 300) showToast();
            });
          }
          return origSend.apply(this, arguments);
        };
        XHR.prototype.__wbnAtcToast = true;
      }
    } catch (e) {}
  })();

/* ---- snippets/notify-me-modal.liquid + assets/notifyMe.js ---- */
(function () {

  let currentNotifyMeData = {};
  
  function openNotifyMeModal(productData, variantId, userEmail, phone , userLoggedIn = false, customerId = null, productName = '') {
    const modal = document.getElementById('notifyMeModal');
    const emailInput = document.getElementById('notifyEmailInput');
    const phoneInput = document.getElementById('notifyPhoneInput');
    const submitBtn = document.querySelector('.notify-me-submit-btn');
  
    currentNotifyMeData = {
      productData: productData,
      variantId: variantId,
      userEmail: userEmail,
      phone: phone,
      userLoggedIn: userLoggedIn,
      customerId: customerId,
      productName: productName
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const normalizedEmail = (userEmail || '').trim();
    if (userLoggedIn && emailRegex.test(normalizedEmail)) {
      emailInput.value = normalizedEmail;
    } else {
      emailInput.value = '';
    }
  
    phoneInput.value = '';
  
    const validateInput = () => {
      const isEmailValid = emailRegex.test(emailInput.value);
      const isPhoneValid = /^\d{10}$/.test(phoneInput.value);
  
      const valid = isEmailValid && isPhoneValid;
      submitBtn.disabled = !valid;
      if (valid) {
        submitBtn.style.opacity = '1';
        submitBtn.style.cursor = 'pointer';
      } else {
        submitBtn.style.opacity = '0.2';
        submitBtn.style.cursor = 'not-allowed';
      }
    };
  
    emailInput.addEventListener('input', validateInput);
    phoneInput.addEventListener('input', validateInput);
  
    validateInput();
    
    modal.style.display = 'block';
    setTimeout(() => {
      modal.classList.add('show');
    }, 10);
  
    document.body.style.overflow = 'hidden';
  
    const oldSuccess = document.querySelector('.notify-me-success-message');
    if (oldSuccess) oldSuccess.remove();
    submitBtn.style.display = 'flex';
    submitBtn.textContent = 'Notify Me';
  }
  
  function closeNotifyMeModal() {
    const modal = document.getElementById('notifyMeModal');
    
    modal.classList.remove('show');
    
    setTimeout(() => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      currentNotifyMeData = {};
    }, 300);
  }
  
  
  async function sendNotifyMeRequest(product_id, variant_id, email , phone,is_logged_in,customer_id, productName, submitBtn) {
    try{
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.2';
      submitBtn.style.cursor = 'not-allowed';
  
      const sanitizedPhone = phone ? phone.toString().replace(/[^0-9]/g, '') : '';
      const response = await fetch(((window.WBN_CFG && window.WBN_CFG.apiBase) || '') + '/api/notify-me', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          product_id: product_id,
          variant_id: variant_id,
          email: email,
          phone: sanitizedPhone,
          is_logged_in: is_logged_in,
          customer_id: customer_id,
          product_name: productName,
          source: window.location.href
        })
      });
      if(!response.ok){
        return false;
      }
      const data = await response.json();
      const mainContent = document.querySelector('.notify-me-main-content');
  
      if(data.success){
        submitBtn.style.display = 'none';
        const successMessage = document.createElement('div');
        successMessage.className = 'notify-me-success-message';
        successMessage.innerHTML = `You will be notified!`;
        if(mainContent){
          mainContent.appendChild(successMessage);
        }else{
          submitBtn.parentNode.appendChild(successMessage);
        }
        return true;
      }else{
        return false;
      }
      
    }catch(error){
      console.error('Error submitting notify me:', error);
      return false;
    }
  }
  
  function notifyMeLoginState() {
    try {
      return localStorage.getItem('kp_customer_id') ? 'logged_in' : 'logged_out';
    } catch (e) {
      return 'logged_out';
    }
  }

  function notifyMeSellingPrice(productData, variantId) {
    if (!productData) return null;

    let paise = null;

    if (typeof productData.variant_price === 'number') {
      paise = productData.variant_price;
    } else if (Array.isArray(productData.variants) && variantId) {
      const match = productData.variants.filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      if (match && typeof match.price === 'number') paise = match.price;
    }

    if (paise === null && typeof productData.price === 'number') paise = productData.price;
    if (typeof paise !== 'number' || !isFinite(paise)) return null;

    return paise / 100;
  }

  function trackNotifyMeSubmitted(productData, variantId, productName) {
    if (typeof clevertap === 'undefined' || !clevertap.event
        || typeof clevertap.event.push !== 'function') return;

    const payload = {
      product_id: String((productData && productData.id) || ''),
      product_name: productName || (productData && productData.title) || '',
      login_state: notifyMeLoginState()
    };

    const price = notifyMeSellingPrice(productData, variantId);
    if (price !== null) payload.product_selling_price = price;

    try {
      clevertap.event.push('notify_me_submitted', payload);
    } catch (e) { /* tracking must never break the submit flow */ }
  }

  async function submitNotifyMe() {
    const submitBtn = document.querySelector('.notify-me-submit-btn');
    const emailInput = document.getElementById('notifyEmailInput');
    const phoneInput = document.getElementById('notifyPhoneInput');
    const { productData, userLoggedIn, variantId, customerId, productName } = currentNotifyMeData;
  
    if (!emailInput.value || !phoneInput.value) {
      alert('Please fill in both email and phone number.');
      return;
    }
  
    const userEmail = emailInput.value;
    const phone = phoneInput.value;
    
    if (!productData || !userEmail) {
      console.error('Missing required data for notify me submission');
      return;
    }
    
    const submitted = await sendNotifyMeRequest(
      productData.id,
      variantId,
      userEmail,
      phone,
      userLoggedIn,
      customerId,
      productName,
      submitBtn
    );

    if (submitted) {
      trackNotifyMeSubmitted(productData, variantId, productName);
    }
  }
  
  document.addEventListener('click', function(e) {
    if (e.target.id === 'notifyMeModal') {
      closeNotifyMeModal();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeNotifyMeModal();
    }
  });

  // formerly assets/notifyMe.js
function getFormatedPhoneNumber(phone) {
    if (!phone) return '';
  
    try {
      const decodedPhone = decodeURIComponent(phone);
      const phoneObj = JSON.parse(decodedPhone);
      if (phoneObj.id) {
        return phoneObj.id.replace(/^\+/, '').replace(/^91/, '');
      }
    } catch (e) {
      return phone
        .replace(/^\+/, '')
        .replace(/[^0-9]/g, '')
        .replace(/^91/, '');
    }
  
    return '';
  }
  
  function getPhoneNumber(){
    const phone = localStorage.getItem("WZRK_K");
    return getFormatedPhoneNumber(phone);
  }
  
  
  function notifyMe(button) {
    let productData = JSON.parse(button.getAttribute('data-product'));
    let variantId = button.getAttribute('data-variant-id');
    const kp_email = localStorage.getItem("kp_email");
    const kp_customer_id = localStorage.getItem("kp_customer_id"); 
    const userLoggedIn = Boolean(kp_email && kp_customer_id);
  
    let productName = productData.title || '';
    let variantName = productData.variant_title || '';
    let combinedProductName = variantName && variantName !== 'Default Title' 
      ? `${productName} ${variantName}` 
      : productName;
  
      const phone = getPhoneNumber();
      if (typeof openNotifyMeModal === 'function') {
        openNotifyMeModal(productData, variantId, kp_email, phone, userLoggedIn, kp_customer_id, combinedProductName);
      } else {
        console.error('openNotifyMeModal function not found. Make sure notify-me-modal.liquid is included.');
      }
    
  }

  window.openNotifyMeModal = openNotifyMeModal;
  window.closeNotifyMeModal = closeNotifyMeModal;
  window.submitNotifyMe = submitNotifyMe;
  window.notifyMe = notifyMe;
  })();

/* ---- snippets/isIOS-pop.liquid ---- */
      (function () {
        function createIosAppModal() {
          try {
            if (document.getElementById('wb-ios-app-modal')) return; // already shown
            const overlay = document.createElement('div');
            overlay.id = 'wb-ios-app-modal';
            overlay.style.position = 'fixed';
            overlay.style.inset = '0';
            overlay.style.background = 'rgba(0,0,0,0.6)';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';
            overlay.style.zIndex = '99999';

            const card = document.createElement('div');
            // Responsive width: use viewport-friendly sizing and enforce mobile max-width
            card.style.width = 'min(680px, 575vw)';
            // Default desktop max, override for small devices below
            card.style.maxWidth = (window.innerWidth <= 680) ? '343px' : '575px';
          //  card.style.height = 'min(680px, 250px)';
            card.style.background = '#fff';
            card.style.borderRadius = '10px';
            card.style.padding = '15px';
            card.style.boxSizing = 'border-box';
            card.style.boxShadow = '0 12px 40px rgba(0,0,0,0.35)';
            card.style.textAlign = 'center';

            // Image at top
            const imgWrap = document.createElement('div');
            imgWrap.style.display = 'flex';
            imgWrap.style.justifyContent = 'center';
            imgWrap.style.marginBottom = '8px';

            const img = document.createElement('img');
            img.src = 'https://cdn.shopify.com/s/files/1/0240/2942/9840/files/Character.png?v=1767592998';
            img.alt = 'App';
            img.style.width = (window.innerWidth <= 680) ? '81px' : '96px';
            img.style.height = (window.innerWidth <= 680) ? '81px' : '96px';
            img.style.objectFit = 'contain';
            img.style.borderRadius = '12px';
            img.style.background = '#fff';
            img.style.padding = '8px';

            imgWrap.appendChild(img);

            const title = document.createElement('h2');
            title.textContent = 'Hang Tight!';
            title.style.margin = '6px 0 6px';
            title.style.fontSize = (window.innerWidth <= 680) ? '16px' : '20px';
            title.style.fontWeight = '700';
            title.style.color = '#000';

            const msg = document.createElement('p');
            msg.textContent = 'To view this product, you will be redirected to install the WellBeing Nutrition app.';
            msg.style.margin = '0 0 10px';
            msg.style.color = '#7c7c7c';
            msg.style.fontSize = '14px';
            msg.style.fontWeight = '400';
            msg.style.lineHeight = '1.4';

            const btn = document.createElement('a');
            btn.className = 'wb-ios-cta';
            btn.textContent = 'Okay';
            btn.style.display = 'inline-block';
            btn.style.textDecoration = 'none';
            btn.style.textAlign = 'center';
            btn.style.background = '#000';
            btn.style.color = '#fff';
            btn.style.border = 'none';
            btn.style.padding = '14px 18px';
            btn.style.borderRadius = '8px';
            btn.style.fontSize = '15px';
            btn.style.cursor = 'pointer';
            btn.style.width = '100%';
            btn.setAttribute('role', 'button');
            btn.setAttribute('rel', 'noopener noreferrer');

            const close = document.createElement('button');
            close.textContent = 'Close';
            close.style.background = 'transparent';
            close.style.border = 'none';
            close.style.color = '#666';
            close.style.marginTop = '12px';
            close.style.cursor = 'pointer';
            close.style.display = 'block';
            close.style.width = '100%';
            close.style.textAlign = 'center';

            card.appendChild(imgWrap);
            card.appendChild(title);
            card.appendChild(msg);
            card.appendChild(btn);
           // card.appendChild(close);
            overlay.appendChild(card);
            document.body.appendChild(overlay);

            // Adjust link (not the raw store URL) so the install attributes
            // instead of counting as Organic. /Getapp maps to the pop-up
            // token; adjust-dynamic-cta.liquid enriches it at click time.
            const appStoreUrl = 'https://wellbeingnutrition.go.link/Getapp';
            // Use anchor href so click performs a normal navigation. Open in new tab to avoid scheme handler issues.
            try { btn.setAttribute('href', appStoreUrl); btn.setAttribute('target', '_blank'); btn.setAttribute('rel', 'noopener noreferrer'); } catch (_) {}

            function removeModal() { try { overlay.remove(); } catch (_) {} }
           // close.addEventListener('click', removeModal);
          //  overlay.addEventListener('click', function (e) { if (e.target === overlay) removeModal(); });
          } catch (e) { console.error('createIosAppModal error', e); }
        }

        document.addEventListener('DOMContentLoaded', function () {
          try {
            var show = false;
            try { show = sessionStorage.getItem('wb_show_ios_modal') === '1'; } catch (_) { show = false; }
            if (show) {
              try { sessionStorage.removeItem('wb_show_ios_modal'); } catch (_) {}
              createIosAppModal();
            }
          } catch (_) {}
        });
      })();

/* ---- snippets/adjust-dynamic-cta.liquid ---- */
(function () {
  // --- edit if your Adjust links change ---
  var GOLINK = "https://wellbeingnutrition.go.link/home";
  var DEEP_LINK = "wellbeingnutrition://home";
  // Web fallback (app not installed). UTMs are appended here via adj_redirect so
  // Shopify attributes the session to the real source instead of "direct".
  var WEB_FALLBACK = "https://bellazamodo.shop/";
  // Adjust link tokens. nav/popup are combined iOS_Android tokens (per-CTA
  // defaults); meta/google are per-platform links created in the dashboard.
  var TOKENS = {
    nav:    "22y0ga4m_22mmslp5",                        // bottom nav / announcement bar / store badges
    popup:  "22ra8o0q_22wf9uxu",                        // app-download pop-up drawer
    meta:   { ios: "1w1gokhr", android: "1wlvboh4" },   // "Meta Campaigns (Web to App)"
    google: { ios: "1vmzglc5", android: "1v2dpzi2" }    // "Google Ads Search"
  };
  // On desktop Adjust can't device-detect and every token falls through to
  // Play Store (verified via curl). Store badges carry data-store so desktop
  // clicks go straight to the matching store instead, skipping Adjust —
  // mobile keeps the attributed flow above untouched.
  var STORE_URLS = {
    ios:     "https://apps.apple.com/in/app/wellbeing-nutrition/id6654917685",
    android: "https://play.google.com/store/apps/details?id=com.coffye.pjfzfc"
  };

  // Per-CTA default token. wire() rewrites the href to /home, so we key off
  // stable signals: the pop-up's original id="banner-button", or its /Getapp
  // branded link (data-adj-link survives the rewrite). Everything else falls
  // back to the nav token.
  function defaultTokenFor(el) {
    var id = (el && el.id) || "";
    var link = (el && el.getAttribute &&
      (el.getAttribute("data-adj-link") || el.getAttribute("href"))) || "";
    if (id === "banner-button" || /\/Getapp\b/i.test(link)) return TOKENS.popup;
    return TOKENS.nav;
  }

  function platform() {
    var ua = (navigator && navigator.userAgent) || "";
    if (/iphone|ipad|ipod/i.test(ua)) return "ios";
    if (/android/i.test(ua)) return "android";
    return "desktop";
  }

  // Route the click to the network-specific Adjust link so the install reports
  // under Meta / Google. Click IDs are deterministic evidence, so they win over
  // utm_source text. Desktop can't install, so it stays on the default token.
  function routeToken(a, el) {
    var p = platform();
    if (p !== "desktop") {
      var src = (a.utm_source || "").toLowerCase();
      if (a.fbclid || /facebook|instagram|meta|^fb$/.test(src)) return TOKENS.meta[p];
      if (a.gclid || a.gbraid || /google/.test(src)) return TOKENS.google[p];
    }
    return defaultTokenFor(el);
  }

  var KEY = "wbn_attr", MAXAGE = 7 * 24 * 60 * 60 * 1000;
  var UTM = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","utm_id"];
  var IDS = ["fbclid","gclid","gbraid"];

  function read() {
    try { var d = JSON.parse(localStorage.getItem(KEY) || "null");
          if (d && Date.now() - d._t < MAXAGE) return d; } catch (e) {}
    return null;
  }
  // Capture on landing. UTMs only exist in the URL on the entry page, so store
  // them; inner-page CTA taps read from storage. Last-touch wins.
  function capture() {
    var p = new URLSearchParams(location.search), got = {}, has = false;
    UTM.concat(IDS).forEach(function (f) { var v = p.get(f); if (v) { got[f] = v; has = true; } });
    if (!has) return;
    var prev = read();
    got.visit_id = (prev && prev.visit_id) ||
      (crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random().toString(16).slice(2));
    got._t = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(got)); } catch (e) {}
  }

  function utmPairs(a) {
    return UTM.filter(function (k) { return a[k]; })
              .map(function (k) { return k + "=" + encodeURIComponent(a[k]); });
  }
  // Build the enriched link fresh from storage, for a specific CTA element.
  function buildLink(el) {
    var p = platform();
    var store = el && el.getAttribute && el.getAttribute("data-store");
    if (p === "desktop" && store && STORE_URLS[store]) return STORE_URLS[store];

    var a = read() || {};
    var utm = utmPairs(a);
    // UTMs travel INSIDE the deep link so the app / web destination captures them
    var deep = DEEP_LINK + (utm.length ? "?" + utm.join("&") : "");
    var params = ["adj_t=" + routeToken(a, el), "adj_deep_link=" + encodeURIComponent(deep)];
    // Mirrors the dashboard's Smart Script config (fallbackClick: iOS only):
    // an owned-web CTA click on iOS must not steal probabilistic attribution
    // from the paid click that brought the user here. Android attributes
    // deterministically via Install Referrer, so it doesn't need the flag.
    if (p === "ios") params.push("adj_engagement_type=fallback_click");
    // Adjust attribution params (reserved -> adj_ prefix on a .go.link domain)
    var source = a.utm_source || (a.fbclid ? "facebook" : (a.gclid || a.gbraid) ? "google" : "direct");
    var adj = { adj_campaign: source + (a.utm_campaign ? " | " + a.utm_campaign : ""), adj_adgroup: a.utm_content,
                adj_creative: a.utm_term, adj_label: a.fbclid || a.gclid || a.gbraid || a.visit_id };
    Object.keys(adj).forEach(function (k) { if (adj[k]) params.push(k + "=" + encodeURIComponent(adj[k])); });
    // Desktop web fallback only: carry the UTMs onto the Shopify URL so the
    // session is attributed to the real source instead of "direct". Skipped on
    // mobile so the Play/App Store install redirect is preserved.
    if (utm.length && p === "desktop") {
      params.push("adj_redirect=" + encodeURIComponent(WEB_FALLBACK + "?" + utm.join("&")));
    }
    // Same UTMs in raw form on the outer link (web analytics / fallback capture)
    return GOLINK + "?" + params.concat(utm).join("&");
  }

  var SEL = 'a[href*="app.adjust.com"], a[href*=".go.link"]';

  // Rewrite whatever CTAs exist now (covers preview / middle-click / new-tab).
  function wire() {
    document.querySelectorAll(SEL).forEach(function (el) {
      el.href = buildLink(el);
      el.removeAttribute("onclick");
    });
  }

  // Delegated click: works even for CTAs injected after load, always fresh.
  // target="_blank" (store badges, the iOS install modal button) opens via
  // window.open so it actually lands in a new tab; everything else keeps
  // navigating the current tab as before.
  document.addEventListener("click", function (e) {
    var el = e.target.closest && e.target.closest(SEL);
    if (!el) return;
    e.preventDefault();
    var link = buildLink(el);
    if (el.getAttribute("target") === "_blank") window.open(link, "_blank", "noopener");
    else location.href = link;
  }, true);

  capture();
  if (document.readyState !== "loading") wire();
  else document.addEventListener("DOMContentLoaded", wire);
})();

/* ---- snippets/notification-drawer.liquid ---- */
  (function () {
    function formatRelativeTimeFromIso(isoString) {
      if (!isoString || typeof isoString !== 'string') return '';
      var t = Date.parse(isoString.trim());
      if (isNaN(t)) return '';
      var now = Date.now();
      var diffMs = now - t;
      var diffS = Math.floor(diffMs / 1000);
      if (diffS < 0) diffS = 0;
      var mins = Math.floor(diffS / 60);
      var hrs = Math.floor(diffS / 3600);
      var days = Math.floor(diffS / 86400);
      if (mins < 1) return 'Just now';
      if (mins < 60) return mins + 'm ago';
      if (hrs < 24) return hrs + 'h ago';
      if (days < 7) return days + 'd ago';
      var weeks = Math.floor(days / 7);
      return weeks + 'w ago';
    }

    function updateNotificationRelativeTimes(root) {
      root = root || document;
      var nodes = root.querySelectorAll('.js-notification-relative-time[data-datetime]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var iso = el.getAttribute('data-datetime');
        var text = formatRelativeTimeFromIso(iso);
        if (text) el.textContent = text;
      }
    }

    function setupNotificationDrawer() {
      var trigger = document.getElementById('notification-centre-button');
      var drawer = document.getElementById('NotificationDrawer');
      var overlay = document.getElementById('NotificationDrawerOverlay');
      var closeBtn = document.getElementById('NotificationDrawerClose');
      var closeBtnMobile = document.getElementById('NotificationDrawerCloseMobile');
      if (drawer) {
        drawer.querySelectorAll('.notification-item__cta').forEach(function (cta) {
          cta.addEventListener('click', function () {
            clevertap.event.push('open_message', {
              message_id: this.dataset.notificationId,
              message_type: 'notification_centre'
            });
          });
        });
      }
      if (!trigger || !drawer || !overlay || !closeBtn || !closeBtnMobile) return;

      function openDrawer() {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        document.documentElement.classList.add('js-notification-drawer-open');

        clevertap.event.push('view_inbox', {
          unread_count: drawer.getAttribute('data-unread-count') || '',
        });
        updateNotificationRelativeTimes(drawer);
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.style.overflow = 'auto';
        document.documentElement.classList.remove('js-notification-drawer-open');
      }

      trigger.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });

      closeBtn.addEventListener('click', function () {
        closeDrawer();
      });

      closeBtnMobile.addEventListener('click', function () {
        closeDrawer();
      });

      overlay.addEventListener('click', function () {
        closeDrawer();
      });

      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' || evt.keyCode === 27) {
          if (drawer.classList.contains('is-open')) {
            closeDrawer();
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setupNotificationDrawer();
        updateNotificationRelativeTimes(document.getElementById('NotificationDrawer'));
      });
    } else {
      setupNotificationDrawer();
      updateNotificationRelativeTimes(document.getElementById('NotificationDrawer'));
    }
  })();
